import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="section-padding bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            话题标签
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            大家都在关心这些话题，热度实时更新
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((item, i) => (
            <div
              key={i}
              className="group flex flex-col items-center gap-1.5 px-5 py-4 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="text-sm font-heading font-bold text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {item.name}
              </span>
              <div className="flex items-center gap-2 text-xs">
                <span className="text-primary-500 font-semibold">{item.heat}</span>
                <span className="text-foreground-400">{item.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}